/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState, useRef } from "react";
import cs from "classnames";
import classes from "./WritingCompetitionForm.module.scss";
import PageTitle from "../../atoms/PageTitle";
import Layout from "../../templates/Layout";
import WritingCompetitionLayout from "../../templates/WritingCompetitionLayout";

import { APPLICATION_ROUTES, COOKIES, PAGE_TITLES } from "../../../constants";
import BirthdayDetails from "./components/BirthdayDetails/BirthdayDetails";
import { StoreContext } from "../../../contexts";
import uploadCharacter from "../../../assets/images/upload-character.png";
import useForm from "./useForm";
import { observer } from "mobx-react-lite";
import { ACTIONS } from "../../../store";
import Loader from "../../atoms/Loader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Loader2 } from "lucide-react";
import { WritingCompetitionAPI } from "../../../api";
import { WRITING_COMPETITON_DATA_KEY } from "../WritingCompetition/WritingCompetition";
import Location from "./components/Location/Location";
import Modal from "../../organisms/Modal";
import { useModal } from "../../../hooks";
// import Icon, { NAMES, SIZES } from "../../atoms/Icon";
import Cookies from "../../../utilities/cookies";
import ToichenStep from "./components/ToichenStep/ToichenStep";
import BrainstormingStep from "./components/BrainstormingStep/BrainstormingStep";
import StoryBuildingStep from "./components/StoryBuildingStep/StoryBuildingStep";
import ProgressBar from "./components/ProgressBar/ProgressBar";

export const CHARACTER_SUBMISSION_KEY = "characterSubmission";

export const defaultCharacter = () => ({
  name: "",
  gender: "",
  age: "",
  height: "",
  livingPlace: "",
  favorite_mitzvah: "",
  favorite_food: "",
  dislikes: "",
  favorite_activity: "",
  favorite_yom_tov: "",
  happiness: "",
  good_at: "",
  wearing: "",
  fun_fact: "",
  family: "",
  additional_info: "",
});

export const defaultCharacterSettings = () => ({
  location: "",
  weather: "",
  transportation: "",
  rules_and_traditions: "",
  where_in_world: "",
  unique_aspects: "",
  additional_info: "",
  place_type: "",
  view: "",
  storyTime: "",
});

export const locationSettings = () => ({
  address: "",
});

const areSpecificCharacterFieldsValid = (characters, requiredFields) => {
  return characters.every((character) => {
    return requiredFields.every(
      (field) =>
        character[field] !== "" &&
        character[field] !== null &&
        character[field] !== undefined
    );
  });
};

const areCharactersSubmitted = (characters) => {
  return characters.every((character) => {
    return character.status && character.status === "submitted";
  });
};

const BYPASS_KEY = "eJwBMADP";

const WritingCompetitionForm = observer(() => {
  const { authorization, common, writingcompetition } =
    useContext(StoreContext);
  const history = useHistory();
  const {
    triggerValidationsWriting,
    triggerValidationsCharacterLocation,
    isNotValidPlaceSettings,
    uploadError,
    setUploadError,
    submitStory,
    isNotValidCharacterLocation,
    toichenPossuk,
    toichenLesson,
    storyWhereWhen,
    character1Name,
    character1Age,
    character1About,
    character2Name,
    character2Age,
    character2About,
    character3Name,
    character3Age,
    character3About,
    storyProblem,
    storySolution,
    storyBeginning,
    storyMiddle,
    storyEnd,
    ...props
  } = useForm();
  const [submitError, setSubmitError] = useState([]);
  const [localUpload, setLocalUpload] = useState(false);
  const [draftSavedMessage, setDraftSavedMessage] = useState(false); // New state
  const [currentStep, setCurrentStep] = useState(1);
  const [uploadingImages, setUploadingImages] = useState(false);
  const uploadPromiseRef = useRef(null); // Track the current upload promise
  const saveDraftButtonRef = useRef(null); // Ref for Save Draft button
  const isSavingDraftRef = useRef(false); // Track if save is in progress to prevent multiple simultaneous saves
  const autoSaveTimeoutRef = useRef(null); // Track auto-save timeout to allow cancellation

  const steps = ["Writer Profile", "Toichen", "Brainstorming Time", "Story Building"];

  const confirmationModal = useModal();
  const getAction = ACTIONS.WRITING_COMPETITON.GET_SUBMISSION;
  const url = new URL(window.location.href);

  useEffect(() => {
    if (authorization.isAuthenticated) {
      common.set(WRITING_COMPETITON_DATA_KEY, null);

      writingcompetition[`${getAction}`]();
    }
  }, [authorization.isAuthenticated]);

  const submissionData = common.get(CHARACTER_SUBMISSION_KEY);

  useEffect(() => {
    let submissionData = writingcompetition.submissionData;
    if (!submissionData || submissionData.length == 0) {
      // todo: if already submitted, redirected to success page.
      submissionData = {};

      // Initialize only necessary fields for new step-based form
      submissionData.writer_photos = [];
      submissionData.selected_childs = [];
      submissionData.status = "pending";
      submissionData.location = { ...locationSettings() };

      // Initialize step data
      submissionData.toichen = {
        possuk: "",
        lesson: "",
      };
      submissionData.brainstorming = {
        whereWhen: "",
        characters: [
          { name: "", age: "", about: "" },
          { name: "", age: "", about: "" },
          { name: "", age: "", about: "" },
        ],
        problem: "",
        solution: "",
      };
      submissionData.storyBuilding = {
        beginning: "",
        middle: "",
        end: "",
      };
    } else {
      // Convert writer_photo array to writer_photos if needed
      if (submissionData.writer_photo && Array.isArray(submissionData.writer_photo)) {
        submissionData.writer_photos = submissionData.writer_photo;
      } else if (!submissionData.writer_photos) {
        submissionData.writer_photos = [];
      }

      // Ensure location object exists
      if (!submissionData.location) {
        submissionData.location = { ...locationSettings() };
      }
    }
    common.set(CHARACTER_SUBMISSION_KEY, submissionData);
  }, [writingcompetition.submissionData]);

  // Load saved data into form fields when component mounts or when submissionData changes
  useEffect(() => {
    const savedData = common.get(CHARACTER_SUBMISSION_KEY);
    if (savedData && writingcompetition.submissionData) {
      // Load location data
      if (savedData.location && savedData.location.address && !props.characterFormLocation.value) {
        props.characterFormLocation.onChange({
          target: { value: savedData.location.address },
          touched: false,
        });
      }

      // Load Toichen data
      if (savedData.toichen) {
        if (savedData.toichen.possuk && !toichenPossuk.value) {
          toichenPossuk.onChange({ target: { value: savedData.toichen.possuk } });
        }
        if (savedData.toichen.lesson && !toichenLesson.value) {
          toichenLesson.onChange({ target: { value: savedData.toichen.lesson } });
        }
      }

      // Load Brainstorming data
      if (savedData.brainstorming) {
        if (savedData.brainstorming.whereWhen && !storyWhereWhen.value) {
          storyWhereWhen.onChange({ target: { value: savedData.brainstorming.whereWhen }, touched: false });
        }
        if (savedData.brainstorming.characters && savedData.brainstorming.characters.length >= 3) {
          const chars = savedData.brainstorming.characters;
          if (chars[0]) {
            if (!character1Name.value) character1Name.onChange({ target: { value: chars[0].name || "" }, touched: false });
            if (!character1Age.value) character1Age.onChange({ target: { value: chars[0].age || "" }, touched: false });
            if (!character1About.value) character1About.onChange({ target: { value: chars[0].about || "" }, touched: false });
          }
          if (chars[1]) {
            if (!character2Name.value) character2Name.onChange({ target: { value: chars[1].name || "" }, touched: false });
            if (!character2Age.value) character2Age.onChange({ target: { value: chars[1].age || "" }, touched: false });
            if (!character2About.value) character2About.onChange({ target: { value: chars[1].about || "" }, touched: false });
          }
          if (chars[2]) {
            if (!character3Name.value) character3Name.onChange({ target: { value: chars[2].name || "" }, touched: false });
            if (!character3Age.value) character3Age.onChange({ target: { value: chars[2].age || "" }, touched: false });
            if (!character3About.value) character3About.onChange({ target: { value: chars[2].about || "" }, touched: false });
          }
        }
        if (savedData.brainstorming.problem && !storyProblem.value) {
          storyProblem.onChange({ target: { value: savedData.brainstorming.problem }, touched: false });
        }
        if (savedData.brainstorming.solution && !storySolution.value) {
          storySolution.onChange({ target: { value: savedData.brainstorming.solution }, touched: false });
        }
      }

      // Load Story Building data
      if (savedData.storyBuilding) {
        if (savedData.storyBuilding.beginning && !storyBeginning.value) {
          storyBeginning.onChange({ target: { value: savedData.storyBuilding.beginning }, touched: false });
        }
        if (savedData.storyBuilding.middle && !storyMiddle.value) {
          storyMiddle.onChange({ target: { value: savedData.storyBuilding.middle }, touched: false });
        }
        if (savedData.storyBuilding.end && !storyEnd.value) {
          storyEnd.onChange({ target: { value: savedData.storyBuilding.end }, touched: false });
        }
      }
    }
  }, [writingcompetition.submissionData]);

  // Save location when user types (only if different from stored value to prevent loops)
  useEffect(() => {
    const currentData = common.get(CHARACTER_SUBMISSION_KEY);
    if (currentData && props.characterFormLocation.value !== undefined) {
      const currentAddress = currentData.location?.address || "";
      const newAddress = props.characterFormLocation.value || "";

      // Only update if the value has actually changed
      if (currentAddress !== newAddress) {
        const updatedSubmissionData = {
          ...currentData,
          location: {
            address: newAddress,
          },
        };
        common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);

        // Clear location error if location is now valid
        if (newAddress && newAddress.trim() !== "" && submitError.length > 0) {
          const filteredErrors = submitError.filter(
            (error) => !error.includes("location") && !error.includes("where do you live")
          );
          setSubmitError(filteredErrors);
        }
      }
    }
  }, [props.characterFormLocation.value]);

  // Auto-clear errors for step 1 when conditions are met
  useEffect(() => {
    if (currentStep === 1 && submitError.length > 0) {
      const shouldHaveErrors = [];

      if (!submissionData?.selected_childs || submissionData.selected_childs.length === 0) {
        shouldHaveErrors.push("Please select at least one child");
      }
      if (isNotValidCharacterLocation) {
        shouldHaveErrors.push("Please provide location where do you live.");
      }
      if (!submissionData?.writer_photos || submissionData.writer_photos.length === 0) {
        shouldHaveErrors.push("Please upload at least one writer photo");
      }

      // If all errors are resolved, clear submitError
      if (shouldHaveErrors.length === 0) {
        setSubmitError([]);
      }
    }
  }, [
    submissionData?.selected_childs,
    submissionData?.writer_photos,
    isNotValidCharacterLocation,
    currentStep,
    submitError.length,
  ]);

  // Auto-clear errors for step 2 when conditions are met
  useEffect(() => {
    if (currentStep === 2 && submitError.length > 0) {
      const shouldHaveErrors = [];

      if (!toichenPossuk.value) {
        shouldHaveErrors.push("Please select a possuk");
      }
      if (!toichenLesson.value) {
        shouldHaveErrors.push("Please provide a lesson from the possuk");
      }

      // If all errors are resolved, clear submitError
      if (shouldHaveErrors.length === 0) {
        setSubmitError([]);
      }
    }
  }, [toichenPossuk.value, toichenLesson.value, currentStep, submitError.length]);

  // console.log(authorization[`success${ACTIONS.AUTHORIZATION.RESIGN_IN}`], 'isAuthenticated')

  useEffect(() => {
    const jwt = Cookies.get(COOKIES.AUTHORIZATION);
    if (jwt?.jwt) {
      if (url.searchParams.get(BYPASS_KEY) == "1") {
        if (writingcompetition.submissionData?.status == "submitted") {
          history.push(APPLICATION_ROUTES.WRITINNG_COMPETITION);
        }
      } else {
        history.push(APPLICATION_ROUTES.WRITINNG_COMPETITION);
      }
    } else {
      history.push(
        `${APPLICATION_ROUTES.SIGN_UP}?redirect=${APPLICATION_ROUTES.WRITINNG_COMPETITION_FORM}?${BYPASS_KEY}=1`
      );
    }
  }, [authorization.isAuthenticated, writingcompetition.submissionData]);


  const savePlaceDraft = async () => {
    // Prevent multiple simultaneous saves
    if (isSavingDraftRef.current || writingcompetition[
      `isLoading${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`
    ]) {
      return;
    }

    // Don't auto-save if already submitted — prevents overwriting status back to pending
    const currentStatus = common.get(CHARACTER_SUBMISSION_KEY)?.status;
    if (currentStatus === "submitted") {
      return;
    }

    // Wait for any ongoing image uploads to complete before saving
    if (uploadingImages && uploadPromiseRef.current) {
      try {
        await uploadPromiseRef.current;
        // Small delay after upload completes to ensure state is updated
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        // If upload fails, continue with save anyway
        console.error("Image upload failed, continuing with save:", error);
      }
    }

    // Set flag to prevent concurrent saves
    isSavingDraftRef.current = true;

    try {
      setSubmitError([]);
      updatedSettings();

      // Get fresh data from common store to preserve existing data
      const currentData = common.get(CHARACTER_SUBMISSION_KEY) || {};

      // Collect ALL data from ALL steps directly from form fields (same as submitStory does)
      // This ensures we capture the current values from all steps, not just the active one
      const updatedSubmissionData = {
        ...currentData,
        // Step 1 data - get from common store (updated by BirthdayDetails and handleImageUpload)
        selected_childs: currentData.selected_childs || [],
        writer_photos: currentData.writer_photos || [],
        status: currentData.status || "pending",
        location: {
          // Get location directly from form field (always current)
          address: props.characterFormLocation.value || currentData.location?.address || "",
        },
        // Step 2 data - get directly from form fields (always current)
        toichen: {
          possuk: toichenPossuk.value || "",
          lesson: toichenLesson.value || "",
        },
        // Step 3 data - get directly from form fields (always current)
        brainstorming: {
          whereWhen: storyWhereWhen.value || "",
          characters: [
            {
              name: character1Name.value || "",
              age: character1Age.value || "",
              about: character1About.value || "",
            },
            {
              name: character2Name.value || "",
              age: character2Age.value || "",
              about: character2About.value || "",
            },
            {
              name: character3Name.value || "",
              age: character3Age.value || "",
              about: character3About.value || "",
            },
          ],
          problem: storyProblem.value || "",
          solution: storySolution.value || "",
        },
        // Step 4 data - get directly from form fields (always current)
        storyBuilding: {
          beginning: storyBeginning.value || "",
          middle: storyMiddle.value || "",
          end: storyEnd.value || "",
        },
      };

      // Save to common store first - this ensures submitStory reads the latest data
      common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);

      // Then submit to API - submitStory will read from common store and form fields
      // submitStory reads from both common store (for selected_childs, writer_photos) 
      // and form fields directly (for all other fields), so this should work correctly
      await submitStory({ draftStatus: true });
    } finally {
      // Reset flag after save completes (whether success or failure)
      isSavingDraftRef.current = false;
    }
  };

  // Auto-save draft every 20 seconds using setTimeout
  // Trigger the Save Draft button click instead of calling function directly
  useEffect(() => {
    const scheduleNextSave = () => {
      // Clear any existing timeout
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
      }

      autoSaveTimeoutRef.current = setTimeout(() => {
        // Don't schedule auto-save if:
        // 1. Currently saving
        // 2. Currently uploading images
        // 3. Draft submit is loading
        // 4. Button doesn't exist
        // 5. Confirmation modal is open
        if (
          !isSavingDraftRef.current &&
          !uploadingImages &&
          !writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`] &&
          saveDraftButtonRef.current &&
          !confirmationModal.isOpened
        ) {
          // Trigger button click to ensure same execution path as manual click
          saveDraftButtonRef.current.click();
        }
        // Schedule the next save
        scheduleNextSave();
      }, 20000);
    };

    // Start the first save after 20 seconds
    scheduleNextSave();

    // Cleanup timeout on unmount
    return () => {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
        autoSaveTimeoutRef.current = null;
      }
    };
  }, [
    writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`],
    confirmationModal?.isOpened,
    uploadingImages, // Re-schedule when upload state changes
  ]);

  useEffect(() => {
    if (
      writingcompetition[`success${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`]
    ) {
      setDraftSavedMessage(true);

      const timer = setTimeout(() => {
        setDraftSavedMessage(false);
      }, 3000);
      // Clean up the timer
      return () => clearTimeout(timer);
    }
  }, [writingcompetition[`success${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`]]);

  const writingCompetitionAPI = new WritingCompetitionAPI();

  const handleImageUpload = async (event) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      // Validate all files
      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      const maxSize = 20 * 1024 * 1024; // 20MB
      const fileArray = Array.from(files);

      // Validate each file
      for (const file of fileArray) {
        if (!allowedTypes.includes(file.type)) {
          setUploadError("Please upload valid images (JPEG, PNG, or GIF).");
          return;
        }

        if (file.size > maxSize) {
          setUploadError("Each image size should be less than 20MB.");
          return;
        }
      }

      // Clear previous error if upload is valid
      setUploadError(null);
      setUploadingImages(true);

      // Create upload promise and store it in ref so savePlaceDraft can wait for it
      const uploadPromise = (async () => {
        try {
          // Upload each image to the API - prioritize this call
          const uploadPromises = fileArray.map(async (file) => {
            const formData = new FormData();
            formData.append("image", file);

            const response = await writingCompetitionAPI.uploadImage(formData);

            if (response.status === 200 || response.status === 201) {
              const data = await response.json();
              return data.url; // Return the URL from the response
            } else {
              throw new Error(`Failed to upload image: ${response.status}`);
            }
          });

          // Wait for all uploads to complete
          const uploadedUrls = await Promise.all(uploadPromises);

          // Get fresh data from common store
          const currentSubmissionData = common.get(CHARACTER_SUBMISSION_KEY) || {};
          const existingPhotos = currentSubmissionData.writer_photos || [];

          // Combine existing photos with newly uploaded ones
          const updatedSubmissionData = {
            ...currentSubmissionData,
            writer_photos: [...existingPhotos, ...uploadedUrls],
          };

          common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);
          setLocalUpload(true);

          // Clear errors related to writer photos when images are uploaded
          if (submitError.length > 0) {
            const filteredErrors = submitError.filter(
              (error) => !error.includes("writer photo")
            );
            setSubmitError(filteredErrors);
          }

          return uploadedUrls;
        } catch (error) {
          console.error("Error uploading images:", error);
          setUploadError("Failed to upload images. Please try again.");
          throw error;
        } finally {
          setUploadingImages(false);
          uploadPromiseRef.current = null; // Clear the ref when done

          // After upload completes, trigger a save to ensure new image URLs are saved
          // Wait a short moment to ensure state updates are complete
          setTimeout(() => {
            if (saveDraftButtonRef.current && !isSavingDraftRef.current) {
              saveDraftButtonRef.current.click();
            }
          }, 500);
        }
      })();

      // Store the promise in ref so savePlaceDraft can wait for it
      uploadPromiseRef.current = uploadPromise;
    }
  };

  const updatedSettings = () => {
    const settingsMap = {
      location: props.placeName.value,
      weather: props.weatherLike.value,
      transportation: props.getAroundInput.value,
      rules_and_traditions: props.rulesAndTradition.value,
      where_in_world: props.whereInWorld.value,
      unique_aspects: props.unique.value,
      additional_info: props.moreAbout.value,
      place_type: props.getPlaceInput.value,
      view: props.getViewInput.value,
      storyTime: props.getStoryTimeRadio.value,
    };

    const locationMap = {
      address: props.characterFormLocation.value || "",
    };

    const updatedSetting = { ...settingsMap };
    const updatedLocation = { ...locationMap };

    common.set(CHARACTER_SUBMISSION_KEY, {
      ...submissionData,
      setting: updatedSetting,
      location: updatedLocation,
    });
  };


  const handleNext = () => {
    // Validate current step before proceeding
    let isValid = true;
    const errors = [];

    if (currentStep === 1) {
      // Validate Writer Profile step
      if (!submissionData.selected_childs || submissionData.selected_childs.length === 0) {
        isValid = false;
        errors.push("Please select at least one child");
      }
      if (isNotValidCharacterLocation) {
        isValid = false;
        triggerValidationsCharacterLocation();
        errors.push("Please provide location where do you live.");
      }
      if (!submissionData.writer_photos || submissionData.writer_photos.length === 0) {
        isValid = false;
        errors.push("Please upload at least one writer photo");
      }
    } else if (currentStep === 2) {
      // Validate Toichen step
      if (!toichenPossuk.value) {
        isValid = false;
        toichenPossuk.touch();
        // errors.push("Please select a possuk");
      }
      if (!toichenLesson.value) {
        isValid = false;
        toichenLesson.touch();
        // errors.push("Please provide a lesson from the possuk");
      }
    } else if (currentStep === 3) {
      // Validate Brainstorming step
      if (!storyWhereWhen.value) {
        isValid = false;
        storyWhereWhen.touch();
      }
      if (!character1Name.value) {
        isValid = false;
        character1Name.touch();
      }
      if (!character1Age.value) {
        isValid = false;
        character1Age.touch();
      }
      if (!character1About.value) {
        isValid = false;
        character1About.touch();
      }
      if (!character2Name.value) {
        isValid = false;
        character2Name.touch();
      }
      if (!character2Age.value) {
        isValid = false;
        character2Age.touch();
      }
      if (!character2About.value) {
        isValid = false;
        character2About.touch();
      }
      if (!character3Name.value) {
        isValid = false;
        character3Name.touch();
      }
      if (!character3Age.value) {
        isValid = false;
        character3Age.touch();
      }
      if (!character3About.value) {
        isValid = false;
        character3About.touch();
      }
      if (!storyProblem.value) {
        isValid = false;
        storyProblem.touch();
      }
      if (!storySolution.value) {
        isValid = false;
        storySolution.touch();
      }
    } else if (currentStep === 4) {
      // Validate Story Building step
      if (!storyBeginning.value) {
        isValid = false;
        storyBeginning.touch();
      }
      if (!storyMiddle.value) {
        isValid = false;
        storyMiddle.touch();
      }
      if (!storyEnd.value) {
        isValid = false;
        storyEnd.touch();
      }
    }

    if (isValid) {
      setSubmitError([]);
      if (currentStep < steps.length) {
        setCurrentStep(currentStep + 1);
        // Scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      // For steps 3 and 4, show generic message and scroll to first error
      if (currentStep === 3 || currentStep === 4) {
        setSubmitError(["Please fill required fields"]);

        // Scroll to first error field
        setTimeout(() => {
          let firstErrorField = null;

          if (currentStep === 3) {
            if (!storyWhereWhen.value) {
              firstErrorField = document.getElementById("story-where-when");
            } else if (!character1Name.value) {
              firstErrorField = document.getElementById("char1-name");
            } else if (!character1Age.value) {
              firstErrorField = document.getElementById("char1-age");
            } else if (!character1About.value) {
              firstErrorField = document.getElementById("char1-about");
            } else if (!character2Name.value) {
              firstErrorField = document.getElementById("char2-name");
            } else if (!character2Age.value) {
              firstErrorField = document.getElementById("char2-age");
            } else if (!character2About.value) {
              firstErrorField = document.getElementById("char2-about");
            } else if (!character3Name.value) {
              firstErrorField = document.getElementById("char3-name");
            } else if (!character3Age.value) {
              firstErrorField = document.getElementById("char3-age");
            } else if (!character3About.value) {
              firstErrorField = document.getElementById("char3-about");
            } else if (!storyProblem.value) {
              firstErrorField = document.getElementById("story-problem");
            } else if (!storySolution.value) {
              firstErrorField = document.getElementById("story-solution");
            }
          } else if (currentStep === 4) {
            if (!storyBeginning.value) {
              firstErrorField = document.getElementById("story-beginning");
            } else if (!storyMiddle.value) {
              firstErrorField = document.getElementById("story-middle");
            } else if (!storyEnd.value) {
              firstErrorField = document.getElementById("story-end");
            }
          }

          if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorField.focus();
          }
        }, 100);
      } else {
        setSubmitError(errors);
      }
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setSubmitError([]);
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const submitScriptHandler = () => {
    setSubmitError([]);
    updatedSettings();

    // Validate all steps
    const errors = [];

    // Step 1 validation
    if (!submissionData.selected_childs || submissionData.selected_childs.length === 0) {
      errors.push("Please select at least one child");
    }
    if (isNotValidCharacterLocation) {
      triggerValidationsCharacterLocation();
      errors.push("Please provide location where do you live.");
    }
    if (!submissionData.writer_photos || submissionData.writer_photos.length === 0) {
      errors.push("Please upload at least one writer photo");
    }

    // Step 2 validation
    if (!toichenPossuk.value) {
      toichenPossuk.touch();
      errors.push("Please select a possuk");
    }
    if (!toichenLesson.value) {
      toichenLesson.touch();
      errors.push("Please provide a lesson from the possuk");
    }

    // Step 3 validation
    if (!storyWhereWhen.value) {
      storyWhereWhen.touch();
      errors.push("Please provide where and when the story happens");
    }
    if (!character1Name.value || !character1Age.value || !character1About.value) {
      errors.push("Please fill all fields for Character 1");
    }
    if (!character2Name.value || !character2Age.value || !character2About.value) {
      errors.push("Please fill all fields for Character 2");
    }
    if (!character3Name.value || !character3Age.value || !character3About.value) {
      errors.push("Please fill all fields for Character 3");
    }
    if (!storyProblem.value) {
      storyProblem.touch();
      errors.push("Please describe the problem or challenge");
    }
    if (!storySolution.value) {
      storySolution.touch();
      errors.push("Please explain how the lesson helps solve the problem");
    }

    // Step 4 validation
    if (!storyBeginning.value) {
      storyBeginning.touch();
      errors.push("Please provide the beginning of the story");
    }
    if (!storyMiddle.value) {
      storyMiddle.touch();
      errors.push("Please provide the middle of the story");
    }
    if (!storyEnd.value) {
      storyEnd.touch();
      errors.push("Please provide the end of the story");
    }

    if (errors.length > 0) {
      setSubmitError(errors);
      // Go to first step with error
      if (!submissionData.selected_childs || submissionData.selected_childs.length === 0 ||
        isNotValidCharacterLocation || !submissionData.writer_photos || submissionData.writer_photos.length === 0) {
        setCurrentStep(1);
      } else if (!toichenPossuk.value || !toichenLesson.value) {
        setCurrentStep(2);
      } else if (!storyWhereWhen.value || !character1Name.value || !storyProblem.value || !storySolution.value) {
        setCurrentStep(3);
      } else {
        setCurrentStep(4);
      }
    } else {
      // All validations passed, prepare submission data
      const currentData = common.get(CHARACTER_SUBMISSION_KEY);
      const updatedSubmissionData = {
        ...currentData,
        status: "pending",
        location: {
          address: props.characterFormLocation.value || "",
        },
        toichen: {
          possuk: toichenPossuk.value,
          lesson: toichenLesson.value,
        },
        brainstorming: {
          whereWhen: storyWhereWhen.value,
          characters: [
            {
              name: character1Name.value,
              age: character1Age.value,
              about: character1About.value,
            },
            {
              name: character2Name.value,
              age: character2Age.value,
              about: character2About.value,
            },
            {
              name: character3Name.value,
              age: character3Age.value,
              about: character3About.value,
            },
          ],
          problem: storyProblem.value,
          solution: storySolution.value,
        },
        storyBuilding: {
          beginning: storyBeginning.value,
          middle: storyMiddle.value,
          end: storyEnd.value,
        },
      };

      common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);
      confirmationModal.onOpen();
    }
  };

  const confirmSubmitHandler = () => {

    if (writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.FINAL_SUBMIT}`]) {
      return;
    }

    // Prepare final submission data with all steps
    const currentData = common.get(CHARACTER_SUBMISSION_KEY);
    const updatedSubmissionData = {
      ...currentData,
      status: "submitted",
      location: {
        address: props.characterFormLocation.value || "",
      },
      toichen: {
        possuk: toichenPossuk.value,
        lesson: toichenLesson.value,
      },
      brainstorming: {
        whereWhen: storyWhereWhen.value,
        characters: [
          {
            name: character1Name.value,
            age: character1Age.value,
            about: character1About.value,
          },
          {
            name: character2Name.value,
            age: character2Age.value,
            about: character2About.value,
          },
          {
            name: character3Name.value,
            age: character3Age.value,
            about: character3About.value,
          },
        ],
        problem: storyProblem.value,
        solution: storySolution.value,
      },
      storyBuilding: {
        beginning: storyBeginning.value,
        middle: storyMiddle.value,
        end: storyEnd.value,
      },
    };

    common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);

    submitStory({
      submissionDataStatus: true,
      onSucess: () => {
        // Cancel auto-save timer to prevent it from firing after submit
        if (autoSaveTimeoutRef.current) {
          clearTimeout(autoSaveTimeoutRef.current);
          autoSaveTimeoutRef.current = null;
        }
        confirmationModal.onClose();
        history.push(APPLICATION_ROUTES.WRITINNG_COMPETITION_SUCCESS);
      },
    });
  };

  return (
    <>
      <PageTitle value={PAGE_TITLES.WRITING_COMPETITION_FORM} />
      <Layout logotype="maor">
        <WritingCompetitionLayout>
          <>
            {writingcompetition[`isLoading${getAction}`] ||
              authorization.isLoadingSignIn ||
              authorization[`isLoading${ACTIONS.AUTHORIZATION.RESIGN_IN}`] ? (
              <Loader />
            ) : (
              <>
                {currentStep === 1 && (
                  <div className={cs(classes.stepContent)}>
                    <h2
                      className={cs(classes.heading, classes.grandstanderFamily)}
                    >
                      Writer Profile
                    </h2>
                    {authorization.isAuthenticated && (
                      <BirthdayDetails {...props} />
                    )}
                    <Location {...props} authorization={authorization} />

                    {/* Writer Photo Upload Section */}
                    <div className={cs(classes.uploadSection)}>
                      <input
                        type="file"
                        id="writerPhotoUpload"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className={cs(classes.fileInput)}
                        style={{ display: "none" }}
                        multiple
                        disabled={uploadingImages}
                      />
                      <label
                        htmlFor="writerPhotoUpload"
                        className={cs(
                          classes.uploadButton,
                          classes.grandstanderFamily
                        )}
                      >
                        <img src={uploadCharacter} alt="uploadCharacter" />
                        Upload Writer Photo
                      </label>
                      {/* <p className={cs(classes.note)}>
                        *You can draw by hand or use any program.
                      </p> */}

                      {/* Display uploaded images */}
                      {submissionData?.writer_photos && submissionData.writer_photos.length > 0 && (
                        <div className={cs(classes.uploadedImagesContainer)}>
                          {submissionData.writer_photos.map((photoUrl, index) => (
                            <div key={index} className={cs(classes.uploadedImageWrapper)}>
                              <img
                                src={photoUrl}
                                alt={`Uploaded Writer Photo ${index + 1}`}
                                className={cs(classes.uploadedImage)}
                              />
                              <button
                                type="button"
                                className={cs(classes.removeImageButton)}
                                onClick={() => {
                                  const currentData = common.get(CHARACTER_SUBMISSION_KEY);
                                  const updatedPhotos = currentData.writer_photos.filter(
                                    (_, i) => i !== index
                                  );
                                  const updatedSubmissionData = {
                                    ...currentData,
                                    writer_photos: updatedPhotos,
                                  };
                                  common.set(CHARACTER_SUBMISSION_KEY, updatedSubmissionData);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      {uploadingImages && (
                        <p className={cs(classes.uploadingMessage)}>Uploading images...</p>
                      )}

                      {/* Error Message */}
                      {uploadError && (
                        <p className={cs(classes.submitError)}>{uploadError}</p>
                      )}
                    </div>
                  </div>
                )}

                {currentStep === 2 && (
                  <div className={cs(classes.stepContent)}>
                    <ToichenStep
                      toichenPossuk={toichenPossuk}
                      toichenLesson={toichenLesson}
                    />
                  </div>
                )}

                {currentStep === 3 && (
                  <div className={cs(classes.stepContent)}>
                    <BrainstormingStep
                      storyWhereWhen={storyWhereWhen}
                      character1Name={character1Name}
                      character1Age={character1Age}
                      character1About={character1About}
                      character2Name={character2Name}
                      character2Age={character2Age}
                      character2About={character2About}
                      character3Name={character3Name}
                      character3Age={character3Age}
                      character3About={character3About}
                      storyProblem={storyProblem}
                      storySolution={storySolution}
                      errorMessage={submitError.length > 0 && submitError[0]}
                    />
                  </div>
                )}

                {currentStep === 4 && (
                  <div className={cs(classes.stepContent)}>
                    <StoryBuildingStep
                      storyBeginning={storyBeginning}
                      storyMiddle={storyMiddle}
                      storyEnd={storyEnd}
                      errorMessage={submitError.length > 0 && submitError[0]}
                    />
                  </div>
                )}

                {/* Only show errors at bottom for step 1 and step 2 */}
                {submitError.length > 0 && (currentStep === 1 || currentStep === 2) && (
                  <ul className={cs(classes.submitError)}>
                    {submitError.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                )}

                <ProgressBar currentStep={currentStep} steps={steps} />

                <div className={cs(classes.formButtons)}>
                  <button
                    ref={saveDraftButtonRef}
                    className={cs(
                      classes.submitScriptButton,
                      classes.saveDraft,
                      classes.grandstanderFamily
                    )}
                    onClick={savePlaceDraft}
                  >
                    {writingcompetition[
                      `isLoading${ACTIONS.WRITING_COMPETITON.DRAFT_SUBMIT}`
                    ] ? (
                      <Loader2 className={cs(classes.loader)} />
                    ) : (
                      "Save Draft"
                    )}
                  </button>

                  {currentStep > 1 && (
                    <button
                      className={cs(
                        classes.submitScriptButton,
                        classes.backButton,
                        classes.grandstanderFamily
                      )}
                      onClick={handleBack}
                    >
                      Back
                    </button>
                  )}

                  {currentStep < steps.length ? (
                    <button
                      className={cs(
                        classes.submitScriptButton,
                        classes.grandstanderFamily
                      )}
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      className={cs(
                        classes.submitScriptButton,
                        classes.submitButton,
                        classes.grandstanderFamily
                      )}
                      onClick={submitScriptHandler}
                    >
                      {writingcompetition[
                        `isLoading${ACTIONS.WRITING_COMPETITON.FINAL_SUBMIT}`
                      ] ? (
                        <Loader2 className={cs(classes.loader)} />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  )}
                </div>

                {draftSavedMessage && (
                  <p className={cs(classes.draftSavedMessage)}>
                    Draft Saved
                  </p>
                )}
              </>
            )}
          </>
        </WritingCompetitionLayout>

        <Modal
          opened={confirmationModal.isOpened}
          onClose={confirmationModal.onClose}
        >
          <div
            data-name="modal-overlay"
            className={cs(classes.overlay)}
            role="button"
          >
            <div className={cs(classes.card)}>
              <div className={cs(classes.confirmationModal)}>
                <h2 className={cs(classes.heading, classes.grandstanderFamily)}>
                  This submission if final!
                </h2>
                <p>
                  <strong className={cs(classes.submissionConfirmationNote)}>
                    Please note:
                  </strong>{" "}
                  You will not be able to make <br /> any changes after pressing
                  “Submit”.
                </p>

                <div className={cs(classes.confirmationModalButton)}>
                  <button
                    className={cs(
                      classes.submitScriptButton,
                      classes.grandstanderFamily,
                      classes.greenColor
                    )}
                    onClick={() => confirmationModal.onClose()}
                  >
                    Continue Editing
                  </button>
                  <button
                    className={cs(
                      classes.submitScriptButton,
                      classes.grandstanderFamily
                    )}
                    onClick={confirmSubmitHandler}
                  >
                    {writingcompetition[
                      `isLoading${ACTIONS.WRITING_COMPETITON.FINAL_SUBMIT}`
                    ] ? (
                      <Loader2 className={cs(classes.loader)} />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Layout>
    </>
  );
});

export default WritingCompetitionForm;
